export const KENLO_PAYMENTS_FIRST_LOAD_TIMEOUT_MS = 90_000;
export const KENLO_PAYMENTS_SUBSEQUENT_TIMEOUT_MS = 15_000;
export const KENLO_PAYMENTS_OPENING_ATTEMPTS = 2;
export const KENLO_PAYMENTS_OPENING_RETRY_DELAY_MS = 1_500;
